import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

/**
 * Blog List Featured Skeleton.
 */
export function BlogListFeaturedSkeleton() {
  return (
    <Card className="overflow-hidden">
      <Skeleton className="h-64 w-full rounded-none" />
      <CardContent className="p-6 space-y-3">
        <Skeleton className="h-7 w-3/4" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-2/3" />
        <div className="flex gap-2 pt-2">
          <Skeleton className="h-6 w-6 rounded-full" />
          <Skeleton className="h-4 w-24" />
        </div>
      </CardContent>
    </Card>
  );
}

/**
 * Blog List Card Skeleton.
 */
export function BlogListCardSkeleton({ featured = false }: Readonly<{ featured?: boolean }>) {
  return (
    <Card className={cn("overflow-hidden", featured && "h-full")}>
      <Skeleton className={cn("w-full rounded-none", featured ? "h-64" : "h-40")} />
      <CardContent className={cn("p-4 space-y-2", featured && "p-6")}>
        <Skeleton className="h-5 w-full" />
        <Skeleton className="h-5 w-4/5" />
        <div className="flex gap-2 pt-2">
          <Skeleton className="h-6 w-6 rounded-full" />
          <Skeleton className="h-3 w-20" />
        </div>
        <div className="flex gap-3 pt-1">
          <Skeleton className="h-3 w-10" />
          <Skeleton className="h-3 w-10" />
          <Skeleton className="h-3 w-16 ml-auto" />
        </div>
      </CardContent>
    </Card>
  );
}

const BLOG_GRID_CARD_SKELETON_KEYS = [
  "blog-grid-1",
  "blog-grid-2",
  "blog-grid-3",
  "blog-grid-4",
  "blog-grid-5",
  "blog-grid-6",
] as const;

/**
 * Blog List Grid Skeleton.
 */
export function BlogListGridSkeleton() {
  return (
    <div className="space-y-8">
      <div>
        <Skeleton className="h-6 w-32 mb-4" />
        <BlogListFeaturedSkeleton />
      </div>
      <div>
        <Skeleton className="h-6 w-40 mb-4" />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {BLOG_GRID_CARD_SKELETON_KEYS.map((skeletonKey) => (
            <BlogListCardSkeleton key={skeletonKey} />
          ))}
        </div>
      </div>
    </div>
  );
}
